import { useContext, useEffect, useState } from "react"
import { Route, Routes, useNavigate, useLocation } from "react-router"
import { CurriculumBook, TextbookProductType } from "shared/types/curriculumTypes"
import TextbookPage from "./TextbookPage"
import { BookContext } from "./BookContext"
import BookUnitsPage from "./BookUnitsPage"
import { AuthContext } from "AuthContext"
import { toast } from "react-toastify"
import * as curriculumRoutes from "shared/routes/curriculumRoutes"

export default function BookPage() {
    const [textbooks, setTextbooks] = useState<CurriculumBook[]>([])
    const auth = useContext(AuthContext)

    const navigate = useNavigate()
    const location = useLocation()
    const state = location.state as { textbookProduct: TextbookProductType } | undefined

    useEffect(() => {
        if (!auth.hasCurriculumAccess) {
            toast.error("You do not have access to the curriculum. Please subscribe to Family Plus to access.")
            navigate("/subscribe")
        }
    })

    // Load textbooks from database
    useEffect(() => {
        curriculumRoutes.getTextbooks()
        .then((data) => {
            const filters: Record<TextbookProductType, string> = {
                eScience21: "Science 21",
                homeschool35: "Grades 3-5 5E+ Science",
                homeschool68: "Grades 6-8 5E+ Science",
            }

            const filterText = filters[state?.textbookProduct]
            const filteredTextbooks = filterText ? data.filter(item => item.name.includes(filterText)) : data

            setTextbooks(filteredTextbooks)
        })
        .catch(() => {
            toast.error("Failed to load textbooks. Please try again later.")
        })
    }, [state?.textbookProduct])

    return (
        <BookContext.Provider value={{ textbooks: textbooks }}>
            <Routes>
                <Route path="" element={<TextbookPage />} />
            <Route path="/units/:bookId" element={<BookUnitsPage />} />
            </Routes>
        </BookContext.Provider>
    )
}

